/* eslint-disable import/order */
import { Icon } from '@iconify/react';
import { PATH_DASHBOARD } from '../../../routes/paths';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import BusinessIcon from '@mui/icons-material/Business';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import User from '@mui/icons-material/Person';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';



const navConfig = [
  {
    items: [
      { title: 'Sub Admin', path: PATH_DASHBOARD.element.element, icon: <ManIcon />},
      { title: 'Membership', path: '/dashboard/usersdata', icon: <User />},
      { title: 'NBCLN Applications', path: '/dashboard/nbcln', icon: <WorkspacePremiumIcon />},
      { title: 'Cotillion Organization', path: PATH_DASHBOARD.rarity.rarity, icon: <Icon icon="fe:warning"/> },
      { title: 'Female Participation', path: PATH_DASHBOARD.dorm.dorm, icon: <WomanIcon />},
      { title: 'Male Participation', path: PATH_DASHBOARD.element.element1, icon: <ManIcon />},
      { title: 'Affiliated (s) or Business', path: PATH_DASHBOARD.tag.tag, icon: <BusinessIcon />},
      { title: 'Artifacts Donation', path: PATH_DASHBOARD.review.review, icon: <VolunteerActivismIcon/> },
      { title: 'Photographer’s Release', path: PATH_DASHBOARD.photographer_release.photographer_release, icon: <VolunteerActivismIcon/> },
      { title: 'Debutante Release', path: PATH_DASHBOARD.debutante_release.debutante_release, icon: <VolunteerActivismIcon/> },
      { title: 'Debutante Minor Release', path: PATH_DASHBOARD.minor_release.minor_release, icon: <VolunteerActivismIcon/> },
      { title: 'News', path: PATH_DASHBOARD.slot.slot, icon:  <Icon icon="teenyicons:appointments-outline"/>},
    ],
  },
  {
    items: [
      // { title: 'Dashboard', path: '/dashboard/home', icon:<Icon icon="ri:dashboard-line" /> },
      { title: 'Membership', path: '/dashboard/usersdata', icon: <User />},
      { title: 'NBCLN Applications', path: '/dashboard/nbcln', icon: <WorkspacePremiumIcon />},
      { title: 'Cotillion Organization', path: PATH_DASHBOARD.rarity.rarity, icon: <Icon icon="fe:warning"/> },
      { title: 'Female Participation', path: PATH_DASHBOARD.dorm.dorm, icon: <WomanIcon />},
      { title: 'Male Participation', path: PATH_DASHBOARD.element.element1, icon: <ManIcon />},
      { title: 'Affiliated (s) or Business', path: PATH_DASHBOARD.tag.tag, icon: <BusinessIcon />},
      { title: 'Artifacts Donation', path: PATH_DASHBOARD.review.review, icon: <VolunteerActivismIcon/> },
      { title: 'Photographer’s Release', path: PATH_DASHBOARD.photographer_release.photographer_release, icon: <VolunteerActivismIcon/> },
      { title: 'Debutante Release', path: PATH_DASHBOARD.debutante_release.debutante_release, icon: <VolunteerActivismIcon/> },
      { title: 'Debutante Minor Release', path: PATH_DASHBOARD.minor_release.minor_release, icon: <VolunteerActivismIcon/> },
      { title: 'News', path: PATH_DASHBOARD.slot.slot, icon:  <Icon icon="teenyicons:appointments-outline"/>},
      // { title: 'appointment', path: PATH_DASHBOARD.appointment.appointment, icon: <Icon icon="teenyicons:appointments-outline"/> },
      // { title: 'Today Shadow', path: PATH_DASHBOARD.appointment.todayShadow, icon: <Icon icon="teenyicons:appointments-outline"/> },
      // { title: 'Student Attendance', path: PATH_DASHBOARD.tag.tag, icon: <Icon icon="ph:student-fill" /> },
      // { title: 'Review', path: PATH_DASHBOARD.review.review, icon: <Icon icon="material-symbols:rate-review-outline"/> },
      // { title: 'Dress Code', path: '/dashboard/dresscode', icon: <Icon icon="material-symbols:dresser"/> },
      // { title: 'Forms', path: '/dashboard/Form', icon: <Icon icon="material-symbols:app-registration"/> },
      // { title: 'Check-in Info', path: '/dashboard/checkinInfo', icon: <Icon icon="material-symbols:library-add-check-outline"/> },
    ],
  },

  // {
  //   subheader: 'management',
  //   items: [
  //     // USER
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'profile', path: PATH_DASHBOARD.user.profile },
  //         { title: 'cards', path: PATH_DASHBOARD.user.cards },
  //         { title: 'list', path: PATH_DASHBOARD.user.list },
  //         { title: 'create', path: PATH_DASHBOARD.user.new },
  //         { title: 'edit', path: PATH_DASHBOARD.user.demoEdit },
  //         { title: 'account', path: PATH_DASHBOARD.user.account },
  //       ],
  //     },

  //     // E-COMMERCE
      // {
      //   title: 'e-commerce',
      //   path: PATH_DASHBOARD.eCommerce.root,
      //   icon: ICONS.cart,
      //   children: [
      //     { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
      //     { title: 'product', path: PATH_DASHBOARD.eCommerce.demoView },
      //     { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
      //     { title: 'create', path: PATH_DASHBOARD.eCommerce.new },
      //     { title: 'edit', path: PATH_DASHBOARD.eCommerce.demoEdit },
      //     { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
      //   ],
      // },

  //     // INVOICE
  //     {
  //       title: 'invoice',
  //       path: PATH_DASHBOARD.invoice.root,
  //       icon: ICONS.invoice,
  //       children: [
  //         { title: 'list', path: PATH_DASHBOARD.invoice.list },
  //         { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.invoice.new },
  //         { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
  //       ],
  //     },

      // BLOG
      // {
      //   title: 'blog',
      //   path: PATH_DASHBOARD.blog.root,
      //   icon: ICONS.blog,
      //   children: [
      //     { title: 'posts', path: PATH_DASHBOARD.blog.posts },
      //     { title: 'post', path: PATH_DASHBOARD.blog.demoView },
      //     { title: 'create', path: PATH_DASHBOARD.blog.new },
      //   ],
      // },
  //   ],
  // },

  // APP
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail,
  //       info: (
  //         <Label variant="outlined" color="error">
  //           +32
  //         </Label>
  //       ),
  //     },
  //     { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //     { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
  //     { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban },
  //   ],
  // },
];

export default navConfig;
